import React, { useState } from 'react';
import AssetInput from '../../../components/AssetInput';
import { Tokens, Validators } from '../../../config/constants';
import { formatUSD } from '../../../helpers';
import { preventOverflow } from '../../../web3/utils';
import ExchangeSwapContent from './ExchangeSwapContent';

const ExchangeStopMarket: React.FC = () => {
    const [amount, setAmount] = useState('');

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;

        setAmount(preventOverflow(value));
    };

    const validators: Validators[] = [];

    const handleConfirm = async () => {
        return '';
    };

    return (
        <ExchangeSwapContent handleConfirm={handleConfirm} validators={validators}>
            <AssetInput
                variant='secondary'
                label='Stop Price'
                sideLabel={<>Mark Price: {formatUSD(31323)}</>}
                asset={Tokens.USDC}
                name='stopPrice'
                value={amount}
                onChange={handleChange}
            />
        </ExchangeSwapContent>
    );
};

export default ExchangeStopMarket;
